import * as React from "react";
import { useAuth } from "@airborne/react-admin";
import { useHistory } from "react-router-dom";

const CustomerInvisiblePage = props => {
  const { user } = useAuth();
  const history = useHistory();
  if (user?.isCustomer) {
    history.replace("");
  }
  return <></>;
};

export default CustomerInvisiblePage;
